import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../utils/style';

export const MARGIN = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const ICON_SIZE = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const defaultContext = makeDefaultStylingContext();

export const COLOR = makeThemeColor(PRIMARY, 0.8);

export const ICON_MARGIN = -1;

export const getContentAdvisoryIconStyle = (picto, screenSize) => ({
  visible: Boolean(picto),
  flexItem: {
    marginRight: ICON_MARGIN,
  },
  iconData: {
    picto,
    viewBox: {
      w: ICON_SIZE[screenSize],
      h: ICON_SIZE[screenSize],
    },
  },
});

export const getInitialStyle = ({ screenSize } = defaultContext) => ({
  h: ICON_SIZE[screenSize],
  flex: {
    direction: 'row',
    alignItems: 'center',
  },
  Label: {
    text: {
      ...getFont(FONT.BERLIN_1, screenSize),
      maxLines: 1,
      verticalAlign: 'middle',
      maxLinesSuffix: '...',
      wordWrap: false,
    },
    flexItem: {
      marginRight: MARGIN[screenSize],
    },
  },
  Icons: {
    h: ICON_SIZE[screenSize],
    flex: {
      direction: 'row',
      alignItems: 'center',
    },
  },
});
